import { createApp } from 'vue'
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/reset.css';

import App from './App.vue'
import router from './router'
import { createPinia } from 'pinia';
const pinia = createPinia();
const debounce = (fn, delay) => {
    let timer
    return (...args) => {
        if (timer) {
            clearTimeout(timer)
        }
        timer = setTimeout(() => {
            fn(...args)
        }, delay)
    }
}

const _ResizeObserver = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends _ResizeObserver{
    constructor(callback) {
        callback = debounce(callback, 200);
        super(callback);
    }
}
router.beforeEach((to, from, next) => {
    document.title = to.meta.title == undefined ? 'PanoMoBi' : String(to.meta.title)
    next();
  })
// Use Pinia with the app
// import store from './store'

createApp(App).use(pinia).use(router).use(Antd).mount('#app')
// use(store)



